import { useCallback, useEffect, useState } from 'react';

// useAsync runs an async function and tracks { data, loading, error }.
// Pass a stable deps array; call reload() to re-run manually.
export function useAsync(asyncFn, deps = []) {
  const [state, setState] = useState({ data: null, loading: true, error: null });

  const memoFn = useCallback(asyncFn, deps); // eslint-disable-line

  const run = useCallback(() => {
    let active = true;
    setState((s) => ({ ...s, loading: true, error: null }));
    memoFn()
      .then((data) => active && setState({ data, loading: false, error: null }))
      .catch((error) => active && setState({ data: null, loading: false, error }));
    return () => {
      active = false;
    };
  }, [memoFn]);

  useEffect(() => run(), [run]);

  return { ...state, reload: run };
}
